/* eslint-disable @typescript-eslint/naming-convention */
import {
  DocumentLinks,
  ResourceCardButton,
  ResourceCardTooltip,
  ResourceIcon,
  ResourceState,
  UserGuide,
  VideosLinks,
} from '../types';

export const featureKey = 'resourcePage';
export const DEFAULT_RESOURCE_PAGE: ResourceState = {
  resources: [],
  isLoading: true,
};

export const videoLinks: VideosLinks = new Map([
  [
    'Getting Started with eReview Manager',
    {
      description:
        'This video presents a high level overview of eReview Manager.',
      name: 'Getting Started with eReview Manager',
    },
  ],
  [
    'Getting Started with eReview Manager',
    {
      description:
        'This video presents a high level overview of eReview Manager.',
      name: 'Getting Started with eReview Manager',
    },
  ],
  [
    'Getting Started with eReview Manager',
    {
      description:
        'This video presents a high level overview of eReview Manager.',
      name: 'Getting Started with eReview Manager',
    },
  ],
  [
    'Making a Submission',
    {
      description:
        'This video walks you through the various submission processes within eReview Manager.',
      name: 'Making a Submission',
    },
  ],
  [
    'Collaboration Hub ',
    {
      description:
        'This video provides an overview to the Collaboration Hub as well as guidance on how to respond to messages and export Collaboration Hub content.',
      name: 'Collaboration Hub',
    },
  ],
  [
    'Team Management',
    {
      description:
        'This video explains how to manage teams, permissions, and submission invitations.',
      name: 'Team Management',
    },
  ],
  [
    'User Profile Menu',
    {
      description:
        'This video covers the User Profile menu options, managing preferences, and support options.',
      name: 'User Profile Menu',
    },
  ],
  [
    'Managing Table Date',
    {
      description:
        'This video demonstrates how you can control the display of data within eReview Manager.',
      name: 'Managing Table Date',
    },
  ],
  [
    'Locating and Downloading Outcome Documents',
    {
      description:
        'This video covers how to locate and download outcome documents.',
      name: 'Locating and Downloading Outcome Documents',
    },
  ],
]);

export const documentLinks: DocumentLinks = new Map([
  [
    'Team Management Quick Reference Guide',
    {
      description:
        'This guide explains how to manage teams, permissions, and submission invitations.',
      name: 'Team Management Quick Reference Guide',
    },
  ],
  [
    'Making a Submission Quick Reference Guide',
    {
      description:
        'This guide walks through the process of making submissions in eReview Manager.',
      name: 'Making a Submission Quick Reference Guide',
    },
  ],
  [
    'Collaboration Hub Quick Reference Guide',
    {
      description:
        "This guide walks you through the process of communicating with WCG through eReview Manager's Collaboration Hub.",
      name: 'Collaboration Hub Quick Reference Guide',
    },
  ],
  [
    'Locating and Downloading Outcome Documents Quick Reference Guide',
    {
      description:
        'This guide shows users how to find and download outcome documents in eReview Manager.',
      name: 'Locating and Downloading Outcome Documents Quick Reference Guide',
    },
  ],
]);

export const userGuide: UserGuide = new Map([
  [
    'eReview Manager User Guide',
    {
      description: 'Downloadable PDF of the eReview Manager User Guide.',
      name: 'eReview Manager User Guide',
    },
  ],
]);

/**
 *  @CONSTANT FUNCTIONS FOR GENERATING BUTTONS AND LINKS
 * */
export const videoLinksStatic = (disableBtn: boolean, classPath: string) => {
  const btnLabel = 'Watch Video';
  const resourceIcon: ResourceIcon = {
    class: `${classPath}icon`,
    fontIcon: 'video_library',
    fontSet: 'material-icons-outlined',
  };
  const resourceCardTooltip: ResourceCardTooltip = {
    disableTooltip: false,
    position: 'above',
    tooltipClass: `${classPath}tooltip`,
  };
  const containerClass = `${classPath}container-card`;
  const contentClass = `${classPath}content`;
  const buttonClass = `${classPath}button`;
  const headerClass = `${classPath}header`;
  const heightClass = `${classPath}heightClass`;

  const button: ResourceCardButton = {
    class: buttonClass,
    disabled: disableBtn,
    hide: false,
    label: btnLabel,
    size: 'slim',
  };
  return {
    button,
    containerClass,
    contentClass,
    headerClass,
    heightClass,
    resourceCardTooltip,
    resourceIcon,
  };
};

export const documentLinksStatic = (disableBtn: boolean, classPath: string) => {
  const btnLabel = 'Download Guide';
  const resourceIcon: ResourceIcon = {
    class: `${classPath}icon`,
    fontIcon: 'description_outlined',
    fontSet: 'material-icons-outlined',
  };
  const containerClass = `${classPath}container-card`;
  const contentClass = `${classPath}content`;
  const headerClass = `${classPath}header`;
  const heightClass = `${classPath}height`;
  const button: ResourceCardButton = {
    class: `${classPath}button`,
    disabled: disableBtn,
    hide: false,
    label: btnLabel,
    size: 'slim',
  };
  const resourceCardTooltip: ResourceCardTooltip = {
    disableTooltip: false,
    position: 'above',
    tooltipClass: `${classPath}tooltip`,
  };

  return {
    button,
    containerClass,
    contentClass,
    headerClass,
    heightClass,
    resourceCardTooltip,
    resourceIcon,
  };
};

export const userGuideStatic = (disableBtn: boolean, classPath: string) => {
  const containerClass = `${classPath}user-guide`;
  const contentClass = `${classPath}user-guide-content`;
  const resourceCardTooltip: ResourceCardTooltip = {
    disableTooltip: false,
    position: 'below',
    tooltipClass: `${classPath}tooltip`,
  };
  return {
    button: {
      class: `${classPath}user-guide-button`,
      disabled: disableBtn,
      hide: false,
      label: 'Download Guide',
      size: 'slim',
    },
    containerClass,
    contentClass,
    headerClass: `${classPath}user-guide-header`,
    heightClass: `${classPath}user-guide-height`,
    resourceCardTooltip,
  };
};
